<template>

    <button :type="type"
        class="inline-flex items-center
            border-transparent
            tracking-widest
            active:bg-opacity-90
            outline-none
            disabled:opacity-25
            transition
            pt-6 pb-5 px-8 sm:px-10 bg-blue rounded-xl text-white font-nexa text-lg hover:bg-dark-blue">

        <slot></slot>

    </button>

</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    })
</script>
